import React, { useEffect, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { getItem } from '../../utils/localStorage';
import CVAccordion from './CVAccordion';
import CVForm from './CVForm';
import { addProfileCVs, getHotelInfo, getLocationInfo } from './apiCaller';
import { showSuccessMessage } from '../../helpers/showMessage';
import { ButtonLarge } from './../../app/common/sharedComponents/buttons/ButtonLarge';
import { ButtonBlockColumn } from './../../app/common/sharedStyledComponents/GenericStyles.styled';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: #fff;
  width: 100%;
  padding-bottom: 100px;
`;

const Header = styled('div')`
  background: #08142f;
  font-family: 'Source Sans Pro', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 28px;
  display: flex;
  align-items: center;
  color: #ffffff;
  height: 40px;
  padding: 0 1rem 0 1rem;
`;

const ButtonContainer = styled.div`
  margin-top: 15px;
`;

function convertToTitleCase (inputText) {
  return (
    inputText &&
    inputText.replace(
      /([a-z])([A-Z])/g,
      // tslint:disable-next-line:only-arrow-functions
      function (match, firstChar, secondChar) {
        return `${firstChar} ${secondChar}`;
      }
    )
  );
}

function convertToTitleCaseAndCapitalizeFirst (inputText) {
  const titleCaseText = convertToTitleCase(inputText);
  return (
    titleCaseText &&
    titleCaseText.charAt(0).toUpperCase() + titleCaseText.slice(1)
  );
}

const StartCV = () => {
  const navigate = useNavigate();
  const userData = getItem('user');
  let department = '';
  let hotelId = '';
  let hotelName = '';
  let level = '';
  let currentJobTitle = '';

  const location = useLocation();
  const loc: any = { ...location };
  const isPreviousHotelExperience =
    loc && loc.state ? loc.state.isPreviousHotelExperience : false;

  if (userData.user && !isPreviousHotelExperience) {
    if (
      userData.user.brands &&
      userData.user.brands[0] &&
      userData.user.brands[0].hotels &&
      userData.user.brands[0].hotels[0]
    ) {
      hotelName = userData.user.brands[0].hotels[0].name;
      hotelId = userData.user.brands[0].hotels[0].id;
    }
    level = userData.user.level;
    currentJobTitle = convertToTitleCaseAndCapitalizeFirst(
      userData.user.jobTitle
    );
    department = getItem('department');
  }
  const [departmentList] = useState<any>([
    { id: 1, value: 'Front Of House' },
    { id: 2, value: 'Housekeeping' },
    { id: 3, value: 'Food And Beverage' },
    { id: 4, value: 'Product' },
    { id: 5, value: 'Other' },
    { id: 6, value: 'Display Only' },
  ]);
  const extractKeys = (obj) => {
    let outputObj = {};
    Object.keys(obj).forEach((value, key) => {
      if (value === 'parent') {
        const extractedKeys = extractKeys(obj[value]);
        outputObj = { ...outputObj, ...extractedKeys };
      }
      // tslint:disable-next-line:triple-equals
      if (value == 'type') {
        outputObj[obj[value]] = obj.name;
      }
    });
    return outputObj;
  };

  useEffect(() => {
    const userData = getItem('user');
    if (userData.user && !isPreviousHotelExperience) {
      if (
        userData.user.brands &&
        userData.user.brands[0] &&
        userData.user.brands[0].hotels &&
        userData.user.brands[0].hotels[0]
      ) {
        const hotelId = userData.user.brands[0].hotels[0].id;

        // get the hotel information
        getHotelInfo(hotelId)
          .then((data) => {
            if (data.locationId) {
              // get the location information
              getLocationInfo(data.locationId).then((locationInfo) => {
                const extractedKeys: any = extractKeys(locationInfo);
                const newValues = [...values];
                if (extractedKeys.city) {
                  newValues[0].city = extractedKeys.city;
                }
                if (extractedKeys.state) {
                  newValues[0].state = extractedKeys.state;
                }
                if (extractedKeys.country) {
                  newValues[0].country = extractedKeys.country;
                }
                setValues(newValues);
              });
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    }
  }, []);

  const initialValues = {
    hotelId: '',
    hotelName: '',
    city: '',
    state: '',
    country: '',
    department: '',
    currentJobTitle: '',
    level: '',
    startDate: '',
    endDate: null,
    jobDescription: '',
  };
  const currentHotelInfo = {
    hotelId,
    hotelName,
    level,
    currentJobTitle,
    department,
  };

  const [values, setValues] = useState<any>([
    {
      ...initialValues,
      hotelId,
      hotelName,
      level,
      currentJobTitle,
      department,
    },
  ]);
  const [errors, setErrors] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentOpenedAccordionItemIndex, setCurrentOpenedAccordionItemIndex] =
    useState(-1);

  const handleChange = (event, index) => {
    const { name, value } = event.target;
    const newCvInputValues = [...values];
    newCvInputValues[index][name] = value;
    setValues(newCvInputValues);
    if (value) {
      const newErrors = [...errors];
      if (newErrors[index]) {
        delete newErrors[index][name];
      }
      setErrors(newErrors);
    } else {
      const newErrors: any = [...errors];
      if (!newErrors[index]) {
        newErrors[index] = {};
      }
      newErrors[index][name] = `${name} is required`;
      setErrors(newErrors);
    }
  };

  const handleAddPosition = () => {
    const validateInputsResult = validateInputs();
    if (!validateInputsResult) {
      return;
    }
    window.scrollTo(0, 0);
    const tempValues = [...values];
    const tempNewValues = { ...initialValues };
    if (!tempNewValues.hotelName) {
      tempNewValues.hotelName = values[0].hotelName;
    }
    if (!tempNewValues.hotelId) {
      tempNewValues.hotelId = values[0].hotelId;
    }
    if (!tempNewValues.city) {
      tempNewValues.city = values[0].city;
    }
    if (!tempNewValues.state) {
      tempNewValues.state = values[0].state;
    }
    if (!tempNewValues.country) {
      tempNewValues.country = values[0].country;
    }
    tempValues.push(tempNewValues);
    setValues(tempValues);
    setCurrentOpenedAccordionItemIndex(-1);
  };

  const validateInputs = (skipLastInputs = false) => {
    setErrors([]);
    // validate input fields
    const newErrors: any = [];
    values.forEach((value, index) => {
      if (
        !(index === 0 && !value.hotelName) &&
        !value.department &&
        !value.currentJobTitle &&
        !value.level &&
        !value.jobDescription &&
        !value.startDate &&
        index > 0 &&
        !value.endDate &&
        index !== 0 &&
        index === values.length - 1 &&
        skipLastInputs
      ) {
        return;
      }
      if (
        (index === 0 && !value.hotelName) ||
        !value.department ||
        !value.currentJobTitle ||
        !value.level ||
        !value.jobDescription ||
        !value.startDate ||
        (index > 0 && !value.endDate) ||
        (!value.hotelId && (!value.city || !value.state || !value.country))
      ) {
        if (!newErrors[index]) {
          newErrors[index] = {};
        }
        if (index === 0 && !value.hotelName) {
          newErrors[index].hotelName = 'Hotel Name is required';
        }
        if (!value.department) {
          newErrors[index].department = 'Department is required';
        }
        if (!value.currentJobTitle) {
          newErrors[index].currentJobTitle = 'Job Title is required';
        }
        if (!value.level) {
          newErrors[index].level = 'Level is required';
        }
        if (!value.jobDescription) {
          newErrors[index].jobDescription = 'Job Responsibilities is required';
        }
        if (!value.startDate) {
          newErrors[index].startDate = 'Start Date is required';
        }
        if (!value.endDate) {
          newErrors[index].endDate = 'End Date is required';
        }
        if (!value.hotelId) {
          if (!value.city) {
            newErrors[index].city = 'City is required';
          }
          if (!value.state) {
            newErrors[index].state = 'State is required';
          }
          if (!value.country) {
            newErrors[index].country = 'Country is required';
          }
        }
      }
      if (value.jobDescription && !value.jobDescription.trim()) {
        if (!newErrors[index]) {
          newErrors[index] = {};
        }
        newErrors[index].jobDescription = 'Job Responsibilities is required';
      }
      if (value.hotelName && !value.hotelName.trim()) {
        if (!newErrors[index]) {
          newErrors[index] = {};
        }
        newErrors[index].hotelName = 'Hotel Name is required';
      }
      if (value.country && !value.country.trim()) {
        if (!newErrors[index]) {
          newErrors[index] = {};
        }
        newErrors[index].country = 'country is required';
      }
      if (value.state && !value.state.trim()) {
        if (!newErrors[index]) {
          newErrors[index] = {};
        }
        newErrors[index].state = 'State is required';
      }
      if (value.city && !value.city.trim()) {
        if (!newErrors[index]) {
          newErrors[index] = {};
        }
        newErrors[index].city = 'country is required';
      }
      if (value.currentJobTitle && !value.currentJobTitle.trim()) {
        if (!newErrors[index]) {
          newErrors[index] = {};
        }
        newErrors[index].currentJobTitle = 'Job Title is required';
      }
    });
    if (newErrors.length > 0) {
      setErrors(newErrors);
      return false;
    }
    return true;
  };

  const handleCVSave = async () => {
    const validateInputsResult = validateInputs(true);
    if (!validateInputsResult) {
      return false;
    }

    setIsLoading(true);
    let modifyValues = [...values];
    modifyValues = modifyValues.filter((value, index) => {
      // if department is not set then remove the entry
      if (!value.department) {
        return false;
      }
      if (!isPreviousHotelExperience) {
        value.isVerified = true;
      }
      for (const key in value) {
        if (typeof value[key] === 'string' && value[key]) {
          value[key] = value[key].trim();
        }
      }
      return value;
    });

    await addProfileCVs(modifyValues);

    showSuccessMessage('CV Saved Successfully');
    setIsLoading(false);
    setErrors([]);
    navigate('/profile/cv');
    return true;
  };

  return (
    <Container>
      <div className="pilot-header background-08142f w-100">
        <AppHeader />
        <Header>Profile</Header>
      </div>
      <div className="p-17">
        {values.slice(0, -1).length > 0 &&
          values.slice(0, -1).map((cvValues, index) => {
            return (
              // tslint:disable-next-line:jsx-key
              <CVAccordion
                values={values}
                index={index}
                errors={errors}
                handleChange={handleChange}
                setErrors={setErrors}
                setValues={setValues}
                currentOpenedAccordionItemIndex={
                  currentOpenedAccordionItemIndex
                }
                setCurrentOpenedAccordionItemIndex={
                  setCurrentOpenedAccordionItemIndex
                }
                isAddingAnotherPosition={index !== 0}
                departmentList={departmentList}
                isPreviousHotelExperience={isPreviousHotelExperience}
                currentHotelInfo={currentHotelInfo}
              />
            );
          })}

        <CVForm
          formTitle={
            values.length > 1
              ? 'Other positions held at this hotel:'
              : isPreviousHotelExperience
                ? 'Previous Hotel CV Setup:'
                : 'Current Hotel CV Setup'
          }
          values={values}
          errors={errors}
          handleChange={handleChange}
          setErrors={setErrors}
          index={values.length - 1}
          setValues={setValues}
          isAddingAnotherPosition={values.length > 1}
          isPreviousHotelExperience={isPreviousHotelExperience}
          departmentList={departmentList}
          currentHotelInfo={currentHotelInfo}
        />
        <ButtonContainer>
          <ButtonBlockColumn>
            <ButtonLarge
              title={
                isPreviousHotelExperience
                  ? 'Add a Position in Previous hotel'
                  : 'Add a Position in Current Hotel'
              }
              onClick={() => {
                handleAddPosition();
              }}
              backgroundColor="oxfordBlue"
              disabled={isLoading}
            />
            <ButtonLarge
              onClick={() => {
                handleCVSave();
              }}
              title="Save"
              outlined={true}
              inverted={true}
              disabled={isLoading}
            />
          </ButtonBlockColumn>
        </ButtonContainer>
      </div>
    </Container>
  );
};

export default StartCV;
